/**
 * 이 모듈이 소유하는 경로.
 *
 * 진행 중인 Probe 의 uuid 는 **라우트가 든다** — BE 에 데이터셋별 Probe 목록 API 가 없어
 * 접수 응답이 유일한 출처이고, 그 값을 개인 브라우저 저장소에 가두면 조직 공용 이력이 사람마다
 * 갈린다. 목록 API 가 생기면 이 경로는 선택 상태의 표현으로 남는다.
 */
export const datasetsListPath = "/datasets";
export const scannedResultsPath = "/scanned-results";

export function datasetDetailPath(datasetUuid: string): string {
  return `${datasetsListPath}/${datasetUuid}`;
}

/** 이 Dataset 의 상세 경로인지(고른 Probe 경로 포함). 섹션 탭 · Probe 선택은 같은 상세 안의 이동이다. */
export function isDatasetDetailPath(pathname: string, datasetUuid: string): boolean {
  const base = datasetDetailPath(datasetUuid);
  return pathname === base || pathname.startsWith(`${base}/`);
}

export function datasetProbePath(datasetUuid: string, probeUuid: string): string {
  return `${datasetDetailPath(datasetUuid)}/probes/${probeUuid}`;
}
